import { render, staticRenderFns } from "./videoPlayCom22.vue?vue&type=template&id=75b5cfcd&scoped=true"
import script from "./videoPlayCom22.vue?vue&type=script&lang=js"
export * from "./videoPlayCom22.vue?vue&type=script&lang=js"
import style0 from "./videoPlayCom22.vue?vue&type=style&index=0&id=75b5cfcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b5cfcd",
  null
  
)

export default component.exports